import React, { Component } from 'react';
import {
  FootContainer,
  HeadContainer,
  ItemContainer,
  ItemFootContainer,
  ItemHeadContainer,
  DivideContainer,
  ItemWrapperContainer,
  NotFoundContainer,
} from './';

class Repeater extends Component {
  constructor(props) {
    super(props);

    this.keyIdx = 0;
    this.startIdx = 0;
  }

  genKey() {
    this.keyIdx = this.keyIdx + 1;
    return this.keyIdx;
  }

  renderItem(children, arrayData, propName, reverse, newComponent) {
    let head = null;
    let itemWrapper = null;
    let itemHead = null;
    let item = null;
    let itemFoot = null;
    let divide = [];
    let foot = null;
    let notFound = null;
    let renderComponents = [];
    if (newComponent === false) {
      this.keyIdx = this.startIdx;
    } else {
      this.startIdx = this.keyIdx;
    }

    // Header 영역 //
    if (!Array.isArray(children)) {
      if (children.type === HeadContainer) {
        head = children;
      }
      if (children.type === FootContainer) {
        foot = children;
      }
      if (children.type === ItemContainer) {
        item = children;
      }
      if (children.type === ItemFootContainer) {
        itemFoot = children;
      }
      if (children.type === ItemHeadContainer) {
        itemHead = children;
      }
      if (children.type === NotFoundContainer) {
        notFound = children;
      }
      if (children.type === DivideContainer) {
        divide.push(children);
      }
      if (children.type === ItemWrapperContainer) {
        itemWrapper = children;
      }
    } else {
      children.forEach((child, idx) => {
        if (child.type === HeadContainer) {
          head = child;
        }
        if (child.type === FootContainer) {
          foot = child;
        }
        if (child.type === ItemContainer) {
          item = child;
        }
        if (child.type === ItemWrapperContainer) {
          itemWrapper = child;
        }
        if (child.type === ItemFootContainer) {
          itemFoot = child;
        }
        if (child.type === ItemHeadContainer) {
          itemHead = child;
        }
        if (child.type === NotFoundContainer) {
          notFound = child;
        }
        if (child.type === DivideContainer) {
          divide.push(child);
        }
      });
    }

    if (head) {
      renderComponents.push(
        React.cloneElement(head, {
          key: '_repeater_head',
        })
      );
    }
    if (!arrayData || !Array.isArray(arrayData) || arrayData.length === 0) {
      if (notFound) {
        renderComponents.push(
          React.cloneElement(notFound, {
            key: this.genKey(),
          })
        );
      }
    } else if (arrayData && Array.isArray(arrayData)) {
      let tempArray = [...arrayData];
      if (reverse) {
        tempArray = tempArray.reverse();
      }
      if (itemWrapper) {
        renderComponents.push(
          React.cloneElement(itemWrapper, {
            key: this.genKey(),
            arrayData: tempArray,
            propName: propName,
          })
        );
      } else if (item) {
        let prev = undefined;
        let next = undefined;
        tempArray.forEach((data, index) => {
          next = arrayData[index + 1];
          if (itemHead) {
            renderComponents.push(
              React.cloneElement(itemHead, {
                key: this.genKey(),
                [propName + '_prev']: prev,
                [propName + '_next']: next,
                [propName]: data,
                index: index,
              })
            );
          }
          renderComponents.push(
            React.cloneElement(item, {
              key: this.genKey(),
              [propName]: data,
              [propName + '_prev']: prev,
              [propName + '_next']: next,
              index: index,
            })
          );
          if (itemFoot) {
            renderComponents.push(
              React.cloneElement(itemFoot, {
                key: this.genKey(),
                [propName]: data,
                [propName + '_prev']: prev,
                [propName + '_next']: next,
                index: index,
              })
            );
          }
          if (divide.length > 0) {
            divide.forEach((divideItem) => {
              if (divideItem.props.value) {
                if ((index + 1) % divideItem.props.value === 0) {
                  renderComponents.push(
                    React.cloneElement(divideItem, {
                      key: this.genKey(),
                      [propName]: data,
                      [propName + '_prev']: prev,
                      [propName + '_next']: next,
                      index: index,
                    })
                  );
                }
              }
            });
          }
          prev = data;
        });
      }
    }
    if (foot) {
      renderComponents.push(
        React.cloneElement(foot, {
          key: '_repeater_foot',
        })
      );
    }
    return renderComponents;
  }

  render() {
    const {
      children,
      arrayData,
      propName,
      elementName,
      reverse,
      newComponent = false,
      ...rest
    } = this.props;
    const element = elementName ? elementName : 'r_';
    return React.createElement(
      element,
      { ...rest },
      this.renderItem(children, arrayData, propName, reverse, newComponent)
    );
  }
}

export default Repeater;
